import PolicyPage from "@/components/legal/PolicyPage";
import { POLICY_PAGES } from "@/constants/policies";

export default function TermsAndConditions() {
  return <PolicyPage policy={POLICY_PAGES.terms} />;
}
